import { URLDescriptor } from 'navi';
import { HTMLAttributes } from 'react';

import { ButtonType } from './Button/helpers';

import { ScLink } from './Button/styled';

export interface ButtonProps extends HTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  target?: string;
  href?: string | null;
  to?: string | Partial<URLDescriptor>;
  disabled?: boolean;
  pending?: boolean;
  onLinkClick?: (event: React.MouseEvent<HTMLAnchorElement>) => void;
  buttonType?: ButtonType;
}

export const handleLinkWrapping = (
  Component: React.ComponentType<any>,
  props: ButtonProps
) => {
  const { href, to, target, children, disabled, onLinkClick, ...rest } = props;

  const button = (
    <Component disabled={disabled || rest.pending} {...rest}>
      {children}
    </Component>
  );

  if (href)
    return (
      <a
        className="button-link"
        href={href}
        target={target || '_blank'}
        rel={!target ? 'noopener noreferrer' : undefined}
      >
        {button}
      </a>
    );

  if (to)
    return (
      <ScLink href={to} onClick={onLinkClick}>
        {button}
      </ScLink>
    );

  return button;
};
